import React from 'react';
import { THEME_CONFIG } from '../constants';

const Hero: React.FC = () => {
  return (
    <section id="home" className="relative h-[80vh] min-h-[500px] flex items-center text-white">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('https://i.ibb.co/qMS8nTM3/pexels-tima-miroshnichenko-5355709.jpg')" }}></div>
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl text-center md:text-left">
          <div className="inline-block bg-primary text-white px-4 py-1 rounded-full text-sm font-semibold mb-4">
            +20 Años de Experiencia
          </div>
          <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-4 animate-fade-in-down">
            Cuidamos tu salud como si fuera la nuestra.
          </h1>
          <p className="text-lg md:text-xl mb-8 text-gray-200 animate-fade-in-up">
            En {THEME_CONFIG.clinicName}, combinamos experiencia, tecnología y un trato humano para ofrecerte la mejor atención médica.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start animate-buttons-fade-in-up">
            <a href="/booking" className="bg-primary text-white px-8 py-3 rounded-xl font-bold text-lg hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105 animate-pulse">
              Agenda tu Consulta
            </a>
            <a href="/services" className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-xl font-bold text-lg hover:bg-white hover:text-secondary transition-all duration-300 transform hover:scale-105">
              Conócenos
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;